const tld = 'authereum.com';
export const defaultConfig = {
    xsUri(network) {
        const s = network === 'mainnet' ? '' : `${network}.`;
        return `https://${s}x.${tld}`;
    }
};
